import React from "react";
import { ReactDataTableComponentProps } from "@bb-vendure/admin-ui/react";
import { useState } from "react";
import CustomsClearanceModal from "./CustomsClearanceModal";

export default function CustomsClearanceAction({
  rowItem,
}: ReactDataTableComponentProps<{ id: string }>) {
  const [openModal, setOpenModal] = useState(false);
  const [disbale, setDisable] = useState(false);

  return (
    <>
      <CustomsClearanceModal
        orderId={rowItem.id}
        openModal={openModal}
        setOpenModal={setOpenModal}
        setDisable={setDisable}
      />
      <button
        className="button primary"
        onClick={() => {
          setOpenModal(true);
        }}
        disabled={disbale}
      >
        Action
      </button>
    </>
  );
}
